import { createElement, Fragment } from 'react';
import { bool, node, string } from 'prop-types';
import { buttonTypePropType, sizePropType } from './types/props.js';
import styled from './styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import Flex from 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import { b as iconPropTypes } from './chunk-16546651.js';
import _Button, { ButtonIcon } from './Button/styled.js';
import Spinner from './Spinner/index.js';

var Text = styled.span.withConfig({
  displayName: "Button__Text",
  componentId: "sc-9gxgrv-0"
})(["align-items:center;display:inline-flex;"]);
var SpinnerWrapper = styled(Box).withConfig({
  displayName: "Button__SpinnerWrapper",
  componentId: "sc-9gxgrv-1"
})(["position:absolute;display:flex;align-items:center;justify-content:center;& + ", "{opacity:0;}"], Text);
var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      iconAfter = _ref.iconAfter,
      iconBefore = _ref.iconBefore,
      isLoading = _ref.isLoading,
      isStatic = _ref.isStatic,
      kind = _ref.kind,
      palette = _ref.palette,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "disabled", "iconAfter", "iconBefore", "isLoading", "isStatic", "kind", "palette", "size"]);

  var child = createElement(Fragment, null, iconBefore && createElement(ButtonIcon, {
    a11yHidden: true,
    icon: iconBefore,
    isBefore: true
  }), children, iconAfter && createElement(ButtonIcon, {
    a11yHidden: true,
    icon: iconAfter,
    isAfter: true
  }));
  return createElement(_Button, _extends({
    className: className,
    disabled: disabled,
    isLoading: isLoading,
    isStatic: isStatic,
    kind: kind,
    palette: palette,
    styledSize: size
  }, props), isLoading ? createElement(Fragment, null, createElement(SpinnerWrapper, null, createElement(Spinner, {
    use: Flex,
    color: kind === 'default' ? (palette || '') + "Inverted" : palette,
    size: "20px"
  })), createElement(Text, null, child)) : child);
};
var buttonPropTypes = {
  autoFocus: bool,
  children: node.isRequired,
  className: string,
  disabled: bool,
  id: string,
  iconAfter: iconPropTypes['icon'],
  iconBefore: iconPropTypes['icon'],
  isLoading: bool,
  isStatic: bool,
  kind: buttonTypePropType,
  palette: string,
  size: sizePropType,
  type: string
};
Button.propTypes = buttonPropTypes;
var buttonDefaultProps = {
  autoFocus: false,
  className: undefined,
  disabled: false,
  id: undefined,
  iconAfter: undefined,
  iconBefore: undefined,
  isLoading: false,
  isStatic: false,
  kind: 'default',
  palette: 'default',
  size: 'default',
  type: 'button'
};
Button.defaultProps = buttonDefaultProps; // @ts-ignore

var C = Button;

export { C as a, buttonPropTypes as b, buttonDefaultProps as c, SpinnerWrapper as d };
